import "./AvailableUnitCard.scss"
import React from "react";
import {IAvailableUnit} from "../../interfaces/IAvailableUnit";
import {PriceIndicator} from "../currency/PriceIndicator";

export interface IAvailableUnitCardProps {
  unit: IAvailableUnit
  floorSelector: boolean
}
//
export function AvailableUnitCard(p: IAvailableUnitCardProps) {
  return <>
    {/*<h4>{p.unit.rooms_grouped}-кімнатні від {p.unit.min_cost} {p.unit.currency_company}</h4>*/}
    <article data-component="AvailableUnitCard">
      <header>
        <img
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src="https://res.cloudinary.com/estoffice-com/image/upload/f_webp,fl_awebp,q_auto/v1736242520/default_img_flat";
          }}
          src={p.unit.image_url} alt={"Floor plan"}
        />
      </header>
      <footer>
        <section>
          <label>{p.unit.rooms_grouped}-кімнатна</label>
          ·
          <label>{p.unit.min_area_total} m²</label>
          ·
          <label>{p.unit.min_price} {p.unit.currency_company} m²</label>
          ·
          <label>{p.unit.available_units} квартир</label>
        </section>
        <h5>{p.unit.min_cost} {p.unit.currency_company}</h5>
        <div><PriceIndicator level={1}/></div>
      </footer>
      {/*<UnitFavAction unitGroupId={p.unitGroup.id}/>*/}
      {/*<UnitImages images={p.unitGroup.images}/>*/}
      {/*{p.floorSelector?<UnitGroupFloorSelector unitGroup={p.unitGroup} currency={p.currency}/>:null}*/}
    </article>
  </>
}